import React, { Component } from 'react';
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import { NotificationManager } from 'react-notifications';
import {
   contractAllStudent,
   detailsIDCard
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ViewIDCard from './component/studentidcard.js';

class StudentId extends Component {

   constructor(props) {
      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         viewdiv: true,
         adddiv: false,
         vid: false,
         editdiv: false,
         lsttype: [],
         selshot: '',
         seltype: '',
         seldrill: '',
         eid: '',
         frm:1,
      };
      this.onAddSession1 = this.onAddSession1.bind(this);
      this.onBackSection = this.onBackSection.bind(this);
   }

   componentDidMount() {
      this.props.contractAllStudent();
   }

   onBackSection() {
      this.setState({
         viewdiv: true,
         vdiv: false,
      });
   }

   onAddSession1(ctsID) {
      this.props.detailsIDCard(ctsID)
        .then((data) => {
          if (data.status === 2) {
            
            NotificationManager.error("Contract not available");
            this.setState({
              vid: false,
            });
          } else {
            this.setState({
              vid: true,
              viewdiv: false,
            });
          }
        })
    }

   render() {
      const { match, contractstudentlist, loading } = this.props;
      const options = {
         filterType: 'dropdown',
         rowsPerPage: 50,
         responsive:'standard',
         rowsPerPageOptions: [50, 100, 150],
         selectableRowsHideCheckboxes: true,
      };

      const columns = [
         { name: "no", label: "NO" },
         { name: "studentname", label: "Student Name" },
         { name: "Parentname", label: "Parent Name" },
         { name: "Parentemail", label: "Parent Email" },
         { name: "action", label: "ACTION" },
      ];

      const tabledata = contractstudentlist.map((assmntval, idx) => {
         const ebtn = (
            <MatButton className="btn-info mr-10 mb-10 text-white" onClick={() => this.onAddSession1(assmntval.ctsID)}>
               ID card
            </MatButton>
         );

         let studname = "";
         if (assmntval.cts_studentid !== 0) {
            studname = `${assmntval.uud_firstName} ${assmntval.uud_lastName}`;
         } else {
            studname = `${assmntval.cts_studentname} ${assmntval.cts_studentlname}`;
         }

         return {
            no: idx + 1,
            studentname: studname,
            Parentname: assmntval.cts_parentname,
            Parentemail: assmntval.cts_parentemail,
            action: ebtn,
         };
      });

      return (
         <div className="saas-dashboard">
            <Helmet>
               <title> Student iD | {AppConfig.appTitle}</title>
               <meta name="description" content="Golf" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.studentid" />} match={match} />

            {this.state.viewdiv && (
               <div className="col-sm-12 col-lg-12">
                  <RctCollapsibleCard heading="List" fullBlock>
                     <MUIDataTable
                        data={tabledata}
                        columns={columns}
                        options={options}
                     />
                  </RctCollapsibleCard>
               </div>
            )}

            {this.state.vid && 
            <ViewIDCard onClick={this.onBackSection} data={this.state}/>
            }
         </div>
      );
   }
}

// const mapStateToProps = ({ studentid }) => {
//    const { contractstudentlist, loading } = studentid;
//    return { contractstudentlist, loading };
// };
const mapStateToProps = ({ contractstudent }) => {
   const { contractstudentlist, loading } = contractstudent;
   return { contractstudentlist, loading };
};


export default connect(mapStateToProps, {
   contractAllStudent,
   detailsIDCard
})(StudentId);
